import { http } from "../../../axios";
import { getCookie } from "../../../utils/cookie";

class planetService {

    savePlanet(payload: any = null) {
        return http().post(`planet/upsert`, payload);
    }
    getPlanetStatus() {
        return http().get(`planet/status/list`);
    }

    getPlanet(id: any) {
        const authToken = getCookie("auth_token");
        if(!authToken){
            return http().get(`planet/get/${id}`);
        }else{
            return http().get(`planet/get_by_id/${id}`);
        }
        
    }
    addComment(payload: any) {
        return http().post(`planet/comment/add`, payload);
    }

    
     addOrbitComment(payload: any) {
        return http().post(`orbit/comment/add`, payload);
    }

    getComments(payload: any) {
        return http().post(`planet/comment/list`, payload);
    }
     getOrbitPlanet(payload: any) {
        return http().post(`orbit/planets`, payload);
    }

    addDoc(data: any) {
        return http().post(`planet/document/upload/${data.id}`, data.value);
    }
    getDoc(payload: any) {
        return http().post(`planet/document/list`, payload);
    }
    deletDoc(payload: any) {
        return http().post(`planet/document/delete`, payload);
    }

    removeCitizen(payload: any) {
        return http().post(`planet/citizen/delete`, payload);
    }
    addTimeLine(payload: any) {
        return http().post(`planet/timeline/upsert`, payload);
    }
    editTimeLine(val:any) {
        return http().post(`planet/timeline/upsert/${val.id}`, val.payload);
    }
    deleteTimeLine(id:any) {
        return http().post(`planet/timeline/delete/${id}`);
    }

    addFlag(payload: any) {
        return http().post(`planet/timeline/flag`, payload);
    }
  

    getTimeLine(payload: any) {
        return http().post(`planet/timeline/list`, payload);
    }

    getFlagList(payload: any) {
        return http().post(`planet/timeline/flagedList`, payload);
    }
   
    setLike(payload: any) {
        return http().post(`planet/like`, payload);
    }

    addVolunteer(payload: any) {
        return http().post(`planet/add_volunteer`, payload);
    }
    joinOrbit(payload: any) {
        return http().post(`planet/join/citizen`, payload);
    }
    getVolunteer(payload: any) {
        return http().post(`planet/volunteers/list`, payload);
    }
    deletePlanet(id:any){
        return http().get(`planet/delete/${id}`);
    }

    getApprovalList(payload:any){
        return http().post(`planet/citizen/approval/list`,payload);
    }
    planetApproval(payload:any){
        return http().post(`planet/citizen/approval/action`,payload);
    }
   

}

export default new planetService();